<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

/**
 * Обёртка для анимации появления блока при прокрутке.
 * Повторяет поведение IntersectionObserver с классом `.reveal`.
 */
const root = ref<HTMLElement | null>(null);
const visible = ref(false);

let observer: IntersectionObserver | null = null;

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visible.value = true;
          observer?.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 },
  );

  if (root.value) {
    observer.observe(root.value);
  }
});

onBeforeUnmount(() => {
  observer?.disconnect();
});
</script>

<template>
  <div ref="root" class="reveal" :class="{ 'is-visible': visible }">
    <slot />
  </div>
</template>
